export default "__VITE_ASSET__CTuaqff1__"